import React, { useState } from 'react';
import { ref, get } from "firebase/database";
import { db } from "../firebase";
import Swal from 'sweetalert2';
import './AdminLogin.css';

const AdminLogin = ({ onLoginSuccess }) => {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const configRef = ref(db, 'adminConfig');
      const snapshot = await get(configRef);
      const data = snapshot.val();

      // Default check if DB is empty
      const correctUser = data?.username || 'tradehouse1';
      const correctPass = data?.password || '123123';

      if (user === correctUser && pass === correctPass) {
        // Har session ke liye naya login zaroori hai
        sessionStorage.setItem('adminAuth', 'true');
        onLoginSuccess();
        Swal.fire({ title: 'Welcome Admin', icon: 'success', timer: 1500, showConfirmButton: false });
      } else {
        Swal.fire('Access Denied', 'Invalid Credentials', 'error');
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-box">
        <div className="logo-section">
          <h1>Admin<span>Core</span></h1>
          <p>Trading Platform Management</p>
        </div>
        <form onSubmit={handleLogin}>
          <input 
            type="text" 
            placeholder="Username" 
            onChange={(e) => setUser(e.target.value)}
            required 
          />
          <input 
            type="password" 
            placeholder="Password" 
            onChange={(e) => setPass(e.target.value)}
            required 
          />
          <button type="submit">LOGIN</button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;